import { z } from 'zod'

export const ContentfulOpCoTagSchema = z.union([
  z.literal('aer_lingus'),
  z.literal('british_airways'),
  z.literal('iberia'),
])
export type ContentfulOpCoTag = z.infer<typeof ContentfulOpCoTagSchema>

export const ContentfulMarketTagSchema = z.union([
  z.literal('market_gb'),
  z.literal('market_us'),
  z.literal('market_ie'),
  z.literal('market_es'),
])
export type ContentfulMarketTag = z.infer<typeof ContentfulMarketTagSchema>
